import { fetchProfile, postLogout, userFree, fetchUserLocation } from '@/serves/api/signup'
import { removeToken, removeSignKey, getUserRole, setUserRole, removeUserRole } from '@/utils/cache'
import router from '@/router'
import { setLastPage } from '@/utils/cache'
import analytics from '@/utils/AnalyticsCenter'
import { getQueryString, jumpToSSO } from '@/utils/utils'

const user = {
  namespaced: true,
  state: () => ({
    email: '', // 邮箱
    name: '', // 姓名
    given_name: '', // 姓
    family_name: '', // 名
    nickname: '', // 昵称
    picture: '', // 头像
    email_verified: false, // 邮箱是否验证
    credit: '', // 积分
    role: getUserRole() || '', // 角色
    date_of_birth: '', // 出生日期
    gender: '', // 性别
    tos_agreed_version: false, // 隐私同意
    parent_mail: '', // 父母邮箱
    login: false,
    userId: '', // 用户id
    missing_part: '',
    country_name: '',
    country_id: '',
    person_id: '',
    isFree: false,
    freeStatus: '',
    currency: '-',
    currencyList: [],
    not_set_currency: false,
    isCodeUser: false,
    isParsingLoginCode: false, // 是否在解析登录数据，此时不应该再次进入解析方法
    family_name_first: false, // 是否姓氏优先展示
    ipCountry: '', // IP判断的国家名称，如 '越南'
  }),
  getters: {
    // 实际要展示的用户名顺序
    displayName(state) {
      return state.family_name_first
        ? `${state.family_name} ${state.given_name}` || state.nickname || ''
        : `${state.given_name} ${state.family_name}` || state.nickname || ''
    },
  },
  mutations: {
    SET_CURRENCYLIST(state, payload) {
      state.currencyList = payload || []
    },
    SET_USER(state, payload) {
      console.log('payload', payload)
      if (!payload) {
        return
      }
      state.email = payload.email || ''
      state.name = payload.name || ''
      state.given_name = payload.given_name || ''
      state.family_name = payload.family_name || ''
      state.nickname = payload.nickname || ''
      state.picture = payload.picture || ''
      state.email_verified = payload.email_verified || false
      state.credit = payload.credit || ''
      const tempRole =  payload?.app_metadata?.role || 'learner'
      state.role = tempRole
      setUserRole(tempRole)
      state.date_of_birth = payload?.user_metadata?.date_of_birth || ''
      state.gender = payload?.user_metadata?.gender || 'male'
      state.tos_agreed_version = payload?.user_metadata?.tos_agreed_version || false
      state.parent_mail = payload?.user_metadata?.parent_email || ''
      state.login = payload?.login || true
      state.userId = payload.user_id || ''
      state.missing_part = payload.missing_part || ''
      state.created_at = payload.created_at || ''
      state.last_login = payload.last_login || ''
      state.country_name = payload.country_name || ''
      state.country_id = payload.country_id || ''
      state.person_id = payload.person_id || ''
      state.currency = payload.currency || '-'
      state.not_set_currency = payload.not_set_currency || false
      state.family_name_first = payload.family_name_first || false
    },
    CLEAR_USER(state) {
      state.email = ''
      state.name = ''
      state.given_name = ''
      state.family_name = ''
      state.nickname = ''
      state.picture = ''
      state.email_verified = false
      state.credit = ''
      state.role = ''
      removeUserRole()
      state.date_of_birth = ''
      state.gender = ''
      state.tos_agreed_version = false
      state.parent_mail = ''
      state.login = false
      state.userId = ''
      state.missing_part = ''
      state.country_name = ''
      state.country_id = ''
      state.person_id = ''
      state.isFree = false
      state.freeStatus = ''
      state.currency = ''
      state.not_set_currency = false
      state.isCodeUser = false
      state.ipCountry = ''
    },
    UPDATE_CREDIT(state, credit) {
      state.credit = credit
    },
    UPDATE_PICTURE(state, picture) {
      state.picture = picture
    },
    UPDATE_CERTIFICATES_MESSAGE(state, payload) {
      state.given_name = payload?.given_name || ''
      state.family_name = payload?.family_name || ''
      state.gender = payload?.gender || ''
      state.country_name = payload?.country_name || ''
      state.country_id = payload?.country_id || ''
    },
    SET_USER_FREE(state, isFree) {
      state.isFree = isFree
    },
    SET_USER_FREE_STATUS(state, freeStatus) {
      state.freeStatus = freeStatus
    },
    SET_USER_FREE_ISCODE(state, isCodeUser) {
      state.isCodeUser = isCodeUser
    },
    SET_IP_COUNTRY(state, country) {
      state.ipCountry = country
    },
  },
  actions: {
    // 更新用户信息
    refreshUser({ commit }) {
      return new Promise((resolve, reject) => {
        fetchProfile()
          .then((res) => {
            commit('SET_USER', res.data)
            //登录成功拿到userid，注册用户埋点
            if (res.data.user_id) {
              let userId = res.data.user_id
              analytics.identify(userId)
              let setUserParams = {
                email: res.data.email,
                people_id: res.data.person_id,
                auth0_id: userId,
              }
              console.log('setUserParams', setUserParams)
              analytics.setUserProperties(setUserParams)
              analytics.registerCommonParams({
                logged_in: true,
                people_id: res.data.person_id,
                unlimited: res.data.is_free,
                auth0_id: userId,
              })
            }
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 邮箱验证期间 更新用户信息
    refreshUserWithoutToken({ commit }, { data }) {
      return new Promise((resolve) => {
        console.log('刷新数据 不适用token')
        data.login = false
        commit('SET_USER', data)
        //登录成功拿到userid，注册用户埋点
        resolve()
      })
    },
    // 检查用户是否可以免费考试
    // 免费考试状态
    checkIsFreeTest({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        userFree()
          .then((res) => {
            commit('SET_USER_FREE', res.data.IsFree)
            commit('SET_USER_FREE_STATUS', res.data.FreeStatus)
            commit('SET_USER_FREE_ISCODE', res.data.IsCodeUser)
            // 同时获取IP位置
            dispatch('fetchIpCountry')
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 获取用户IP所在国家
    fetchIpCountry({ commit }) {
      return new Promise((resolve) => {
        fetchUserLocation()
          .then((res) => {
            const country = res.data?.country || ''
            commit('SET_IP_COUNTRY', country)
            resolve(country)
          })
          .catch(() => {
            commit('SET_IP_COUNTRY', '')
            resolve('')
          })
      })
    },
    // 退出登录和登录
    handleLogout({ commit }, { reLogin, steteObj }) {
      console.log('handleLogOut' ,reLogin,steteObj)
      return new Promise((resolve, reject) => {
        // 登录
        if (reLogin) {
          // 如果
          const active_code = getQueryString('active_code')
          if (active_code) {
            return
          }
          setLastPage(window.location.pathname+window.location.search)
          router.push('/')
          console.log('登录handlelogout')
          // 跳转到sso登录页
          removeToken()
          removeSignKey()
          if (steteObj) {
            jumpToSSO(false, steteObj)
          } else {
            jumpToSSO()
          }

          return
        }
        // 退出登录
        postLogout()
          .then(() => {
            removeToken()
            removeSignKey()
            commit('CLEAR_USER')
            analytics.registerCommonParams({
              logged_in: false,
              people_id: '',
              unlimited: '',
              auth0_id: '',
            })
            analytics.clear()
            const needLogin = !!router.history.current?.matched?.some(
              (item) => !!item?.meta?.needLogin
            )
            if (needLogin) {
              router.replace('/')
            } else {
              setLastPage(router.history.current.path)
            }
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
  },
}

export default user
